import React from "react"
import { useTranslation } from "react-i18next"
import { CleanHtml, merchantSelectors, useSelector } from "swiipe.portal.shared"
import { userRelationSelectors } from "../../store/reducers/userRelationReducer"
import "./RebrandingDisclaimerBanner.scss"

interface IRebrandingDisclaimerBanner {}

const RebrandingDisclaimerBanner = ({}: IRebrandingDisclaimerBanner) => {
    const { t } = useTranslation()

    const merchantDetails = useSelector(merchantSelectors.merchantDetails)
    const currentUserRelation = useSelector(userRelationSelectors.currentUserRelation)

    if (currentUserRelation?.relationType !== "Merchant") {
        return null
    }

    const showBannerForCountries = ["dk", "se", "no"]

    if (!showBannerForCountries.includes(merchantDetails?.swMerchant.countryCode.toLowerCase() ?? "")) {
        return null
    }

    return (
        <Banner>
            <b>{t("rebrandingDisclaimerBanner.title")}</b>{" "}
            <CleanHtml
                element="span"
                html={t("rebrandingDisclaimerBanner.text", {
                    link: '<a href="https://aera.id" target="_blank">aera.id</a>',
                })}
            />
        </Banner>
    )
}

const Banner = (props: { children: React.ReactNode }) => {
    return <div className="banner-top-purple">{props.children}</div>
}

export default RebrandingDisclaimerBanner
